export default {
    join:                               { method: 'get', url: 'joins/{id}' },
    attributionsReplicate:              { method: 'post', url: 'attributions/replicate' },
    attributionProcessSendAllPending:   { method: 'post', url: 'attribution_processes/send-all-pending' },
}

